import { Popover as MuiPopover } from '@mui/material'
import { tss } from 'tss-react/mui'
import { PopoverProps } from './types'
import { getPopoverPrimitives } from './variants/primitives'

const useStyles = tss
  .withParams<{
    width?: number
  }>()
  .create(({ width }) => ({
    menu: getPopoverPrimitives(width),
  }))

export function Popover({ width, ...rest }: PopoverProps) {
  const { classes } = useStyles({ width })
  return <MuiPopover PaperProps={{ className: classes.menu }} {...rest}></MuiPopover>
}
